import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getChatSettings } from '../../store/chatSettings';
import Chat from '../Pages/Chat';

function ChatWrapper() {
    const dispatch = useDispatch();
    const location = useLocation();
    const chatSettings = useSelector(state => state.chatSettings.chatSettings);
    const loading = useSelector(state => state.chatSettings.loading);
    
    useEffect(() => {
        // Load chat settings when component mounts
        dispatch(getChatSettings());
    }, [dispatch]);
    
    // Don't render if loading
    if (loading) {
        return null;
    }
    
    const displayMode = chatSettings?.display_mode || 'home_only';
    const isHomePage = location.pathname === '/home' || location.pathname === '/' || location.pathname.endsWith('/home');
    
    // Determine if chat should be displayed
    let shouldDisplay = false;
    let displayStyle = 'full'; // 'full' or 'sidebar'
    
    switch (displayMode) {
        case 'all_pages':
            shouldDisplay = true;
            displayStyle = 'full';
            break;
        case 'sidebar':
            shouldDisplay = true;
            displayStyle = 'sidebar';
            break;
        case 'home_only':
        default:
            shouldDisplay = isHomePage;
            displayStyle = 'full';
            break;
    }
    
    if (!shouldDisplay) {
        return null;
    }
    
    // Render chat based on display style
    if (displayStyle === 'sidebar') {
        return (
            <div className="chat-sidebar-wrapper" style={{
                position: 'fixed',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                width: '350px',
                maxHeight: '80vh',
                zIndex: 1000,
                overflow: 'auto'
            }}>
                <Chat />
            </div>
        );
    }
    
    // Full width display (default)
    return (
        <div className="chat-full-wrapper" style={{ zIndex: 99 }}>
            <Chat />
        </div>
    );
}

export default ChatWrapper;

